var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"rate-chart"},[_c('div',{staticClass:"rate-pie",attrs:{"id":'rate-pie-' + _vm.type}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }